import React from 'react';
import { Clock, Users, BarChart3 } from 'lucide-react';

const MaweredLogo = ({
  size = 'md',
  showGlow = true,
  animated = true,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
    xl: 'w-24 h-24'
  };

  const iconSizes = {
    sm: { main: 'w-5 h-5', secondary: 'w-3 h-3' },
    md: { main: 'w-6 h-6', secondary: 'w-4 h-4' },
    lg: { main: 'w-8 h-8', secondary: 'w-5 h-5' },
    xl: { main: 'w-10 h-10', secondary: 'w-6 h-6' }
  };

  const roundedClasses = {
    sm: 'rounded-2xl',
    md: 'rounded-2xl',
    lg: 'rounded-3xl',
    xl: 'rounded-3xl'
  };

  const glowIntensity = {
    sm: 'blur-md',
    md: 'blur-lg',
    lg: 'blur-lg',
    xl: 'blur-xl'
  };

  const animationClasses = animated
    ? 'transform transition-all duration-300 hover:scale-105 hover:rotate-2'
    : '';

  return (
    <div className={`relative ${animated ? 'group' : ''} ${className}`}>
      {/* Main logo container */}
      <div className={`
        ${sizeClasses[size]}
        ${roundedClasses[size]}
        ${animationClasses}
        bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700
        flex items-center justify-center
        shadow-2xl
      `}>
        {/* Glass overlay */}
        <div className={`
          absolute inset-2
          ${roundedClasses[size]}
          bg-card/20 backdrop-blur-sm
        `}></div>

        {/* Icon composition */}
        <div className="relative flex items-center justify-center">
          {/* Main Users icon */}
          <div className="absolute">
            <Users className={`${iconSizes[size].main} text-white/80`} />
          </div>

          {/* Clock icon - top right */}
          <div className="absolute translate-x-2 -translate-y-1">
            <Clock className={`${iconSizes[size].secondary} text-white/60`} />
          </div>

          {/* BarChart icon - bottom left */}
          <div className="absolute -translate-x-2 translate-y-1">
            <BarChart3 className={`${iconSizes[size].secondary} text-white/60`} />
          </div>
        </div>
      </div>

      {/* Glow effect */}
      {showGlow && (
        <div className={`
          absolute -inset-1
          ${roundedClasses[size]}
          bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700
          opacity-30 ${glowIntensity[size]}
          ${animated ? 'group-hover:opacity-50 transition-all duration-300' : ''}
        `}></div>
      )}
    </div>
  );
};

export default MaweredLogo;
